import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, MoreHorizontal } from 'lucide-react';
import ReactPaginate, { ReactPaginateProps } from 'react-paginate';
import { ButtonProps, buttonVariants } from '../common/Button';
import { cn } from '@/utils/utils';

interface PaginateProps extends ReactPaginateProps {
    size?: ButtonProps['size']
}

export default function Paginate({
    containerClassName,
    pageLinkClassName,
    activeLinkClassName,
    previousLinkClassName,
    previousLabel,
    nextLinkClassName,
    nextLabel,
    breakLabel,
    breakLinkClassName,
    disabledLinkClassName,
    size = 'icon',
    onPageChange,
    pageCount,
    ...props
}: PaginateProps) {
    const paginateLinkClass = buttonVariants({
        variant: 'ghost',
        size
    });

    return (
        <div className='flex flex-row items-center gap-1'>
            {/* Nút chuyển đến trang đầu */}
            <button
                className={cn(paginateLinkClass, 'h-8 w-fit disabled:opacity-50 disabled:text-text-gray-1 hover:text-active hover:bg-transparent')}
                onClick={() => onPageChange?.({ selected: 0 })}
                disabled={props.forcePage === 0}
            >
                <ChevronsLeft className='h-4 w-4' />
            </button>

            <ReactPaginate
                containerClassName={cn('flex flex-row items-center gap-1', containerClassName)}
                pageLinkClassName={cn(paginateLinkClass, pageLinkClassName, 'h-8 w-fit px-2.5 font-normal')}
                activeLinkClassName={cn(
                    buttonVariants({ variant: 'active', size }),
                    activeLinkClassName,
                    'h-8 w-fit px-2.5 font-normal'
                )}
                previousLinkClassName={cn(paginateLinkClass, 'h-8 w-fit px-2.5 hover:text-active hover:bg-transparent', previousLinkClassName)}
                previousLabel={previousLabel ?? <ChevronLeft className='h-4 w-4' />}
                nextLinkClassName={cn(paginateLinkClass, 'h-8 w-fit px-2.5 hover:text-active hover:bg-transparent', nextLinkClassName)}
                nextLabel={nextLabel ?? <ChevronRight className='h-4 w-4' />}
                breakLabel={breakLabel ?? <MoreHorizontal className='h-4 w-4' />}
                breakLinkClassName={cn('flex h-8 w-9 items-center justify-center', breakLinkClassName)}
                disabledLinkClassName={cn('opacity-50 pointer-events-none text-text-gray-1', disabledLinkClassName)}
                onPageChange={onPageChange}
                pageCount={pageCount}
                {...props}
            />

            {/* Nút chuyển đến trang cuối */}
            <button
                className={cn(paginateLinkClass, 'h-8 w-fit disabled:opacity-50 disabled:text-text-gray-1 hover:text-active hover:bg-transparent')}
                onClick={() => onPageChange?.({ selected: pageCount - 1 })}
                disabled={props.forcePage === pageCount - 1}
            >
                <ChevronsRight className='h-4 w-4' />
            </button>
        </div>
    );
}
